module.exports = __webpack_public_path__ + "static/media/alone.894cd1e6.jpg";